import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { ILenderCreditViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ILenderCredit
  extends IItemProps,
    IHasItemDataProps<ILenderCreditViewItem>,
    IHasItemEventProps<ILenderCreditViewItem> {}

export default class LenderCredit extends React.Component<ILenderCredit> {
  public render() {
    return (
      <SharedItemCells
        {...this.props}
        buyerBeforeClosingDisplay="empty"
        nettedOutDisplay="none"
        showLenderPaid={false}
        showRemove={false}
        inputDisplayOptions={{ allowNegative: true }}
        paidByOthersDisplay="empty"
        rowNumberDisplay="empty"
        sellerBeforeClosingDisplay="empty"
        sellerAtClosingDisplay="empty"
        readOnly={!this.props.hasEditPermissions}
      >
        Lender credits
      </SharedItemCells>
    );
  }
}
